import * as React from "react";
import { cn } from "@/shared/lib/utils";

/** Szekció-címke: 11 px / 800 / verzál / +0.12em — a forrásban mondatkezdő nagybetűvel. */
export function SectionLabel({
  className,
  gold,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { gold?: boolean }) {
  return (
    <span
      className={cn("section-label", gold ? "text-gold-text" : "text-muted", className)}
      {...props}
    />
  );
}
